import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "transform-grid-groupby",
  templateUrl: "./transform-grid-groupby.component.html",
})
export class TransformGridGroupbyComponent implements OnInit {

  @Input() public inputTransformations: string[] = [];
  @Input() public switchs: any = {};
  @Output() public updateTransformations: EventEmitter<any> = new EventEmitter();

  public typeTransformation: string = "";

  public ngOnInit(): void {
    if (this.inputTransformations && this.inputTransformations.length) {
      this.typeTransformation = this.inputTransformations[0];
    }
  }

  public typeUpdate(): void {
    this.inputTransformations = [];
    if (this.typeTransformation.length) {
      this.inputTransformations.push(this.typeTransformation);
    }
    this.updateTransformations.emit(this.inputTransformations);
  }

}
